<div class="flex justify-end space-x-2 me-2 mb-2">
  <button
    (click)="expandAll()"
    type="button"
    class="font-medium disabled:text-gray-400 hover:text-gray-500 cursor-pointer hover:scale-110"
    appAgentAction
    agent="sw-part-number-accordion-expand-all"
    businessObject="swPartNumber"
    action="expand"
  >
    <app-chevron-double-down-icon></app-chevron-double-down-icon>
  </button>
  <button
    (click)="collapseAll()"
    type="button"
    class="font-medium disabled:text-gray-400 hover:text-gray-500 cursor-pointer hover:scale-110"
    appAgentAction
    agent="sw-part-number-accordion-collapse-all"
    businessObject="swPartNumber"
    action="toggle"
  >
    <app-chevron-double-up-icon></app-chevron-double-up-icon>
  </button>
</div>
<div class="rounded-md overflow-hidden shadow-md max-h-screen-250 min-h-screen-250 overflow-y-auto">
  @for (nwNumber of getGroupedNwNumbers(); track $index) {
    <h2
      [ngClass]="{
        'bg-gray-100 text-gray-500': isActive(nwNumber),
      }"
    >
      <button
        (click)="toggleActive(nwNumber)"
        type="button"
        class="flex items-center justify-between w-full p-5 font-medium rtl:text-right border-t border-b-0 border-gray-200 hover:bg-gray-100 hover:text-gray-500 gap-3 h-12"
        appAgentAction
        [agent]="'sw-part-number-accordion-toggle-nw-' + nwNumber"
        businessObject="nwNumberErrorMemory"
        [businessId]="nwNumber"
        action="toggle"
      >
        <button
          class="bg-white w-16 text-amazone-orange border border-amazone-orange rounded-md hover:scale-105 hover:bg-amazone-orange hover:text-white shadow cursor-pointer text-sm"
          (click)="openNwNumberErrorMemorySidebar(nwNumber); $event.stopPropagation()"
          type="button"
          appAgentAction
          [agent]="'sw-part-number-accordion-open-nw-' + nwNumber"
          businessObject="nwNumberErrorMemory"
          [businessId]="nwNumber"
          action="open"
        >
          <span>{{ nwNumber }}</span>
        </button>
        <app-chevron-icon [direction]="!isActive(nwNumber) ? arrows.DOWN : arrows.UP" [size]="6"></app-chevron-icon>
      </button>
    </h2>

    @if (isActive(nwNumber)) {
      <div>
        <div class="ps-5 border-t border-b-0 border-gray-200">
          <div>
            @for (major of getMajorParts(nwNumber); track $index) {
              <h2
                [ngClass]="{
                  'bg-gray-100 text-gray-500': isActive(major.nwNumberWithMajorRelease ?? ''),
                }"
              >
                <button
                  (click)="toggleActive(major.nwNumberWithMajorRelease ?? '')"
                  type="button"
                  class="flex items-center justify-between w-full p-5 font-medium rtl:text-right border-t border-b-0 border-gray-200 hover:bg-gray-100 hover:text-gray-500 gap-3 h-12"
                  appAgentAction
                  [agent]="'sw-part-number-accordion-toggle-major-' + (major.nwNumberWithMajorRelease ?? '')"
                  businessObject="nwNumberErrorMemory"
                  [businessId]="major.nwNumberWithMajorRelease"
                  action="toggle"
                >
                  <span>{{ major.nwNumberWithMajorRelease }}</span>
                  <app-chevron-icon
                    [direction]="!isActive(major.nwNumberWithMajorRelease ?? '') ? arrows.DOWN : arrows.UP"
                    [size]="6"
                  ></app-chevron-icon>
                </button>
              </h2>
              @if (isActive(major.nwNumberWithMajorRelease ?? '')) {
                <div>
                  <div class="ps-5">
                    @for (swPartNumber of getSwPartNumbers(major.nwNumberWithMajorRelease ?? ''); track $index) {
                      <div
                        class="grid grid-cols-4 border-t border-b-0 border-gray-200 text-gray-500 hover:bg-gray-100 h-22 @lg:h-12 hover:text-amazone-orange"
                        [ngClass]="{
                          'bg-orange-100': isSelected(swPartNumber.id ?? ''),
                        }"
                      >
                        <div
                          class="flex gap-x-6 col-span-3 cursor-pointer hover:border hover:border-amazone-orange hover:rounded-md"
                          (click)="onSwPartNumberClicked(swPartNumber.id!)"
                          appAgentAction
                          [agent]="'sw-part-number-accordion-open-sw-part-number-' + swPartNumber.id"
                          businessObject="swPartNumber"
                          [businessId]="swPartNumber.id"
                          action="open"
                        >
                          <div class="flex items-center">
                            <p class="ps-5 text-xs @sm:text-base">
                              {{ swPartNumber.displayId }}
                              {{ commonUtils.swPartNumberStateToSymbol(swPartNumber.state) }}
                            </p>
                          </div>
                          <div class="flex-col items-start text-xs self-center hidden @sm:block">
                            <strong>Last Versioning Action by</strong>
                            <p>{{ swPartNumber.modifiedBy ?? 'N/A' }}</p>
                          </div>
                          <div
                            class="flex-col items-start self-center text-xs hidden @md:block @md:col-start-4 @xl:ms-4 @2xl:col-start-3"
                          >
                            <strong>Last Versioning Action at</strong>
                            <p>{{ swPartNumber.modifiedOn | date: 'yyyy.MM.dd HH:mm' }}</p>
                          </div>
                        </div>
                        <div class="@md:col-start-6 col-start-4 flex justify-end gap-4 pe-10">
                          @if (swPartNumber.state == swPartNumberState.Snapshot) {
                            <button
                              *appIfPolicySatisfied="policy.canCreateSwPartNumberSnapshot"
                              (click)="$event.stopPropagation(); updateSnapshotClicked.emit(swPartNumber)"
                              type="button"
                              class="font-medium text-blue-400 disabled:text-gray-400 hover:text-blue-600 cursor-pointer hover:scale-110"
                              appAgentAction
                              [agent]="'sw-part-number-accordion-update-snapshot-' + swPartNumber.id"
                              businessObject="swPartNumber"
                              [businessId]="swPartNumber.id"
                            >
                              <app-refresh-icon></app-refresh-icon>
                            </button>
                            <button
                              *appIfPolicySatisfied="policy.canReleaseSwPartNumberSnapshot"
                              (click)="$event.stopPropagation(); releaseSnapshotClicked.emit(swPartNumber)"
                              type="button"
                              class="font-medium text-red-400 disabled:text-gray-400 hover:text-red-600 cursor-pointer hover:scale-110"
                              appAgentAction
                              [agent]="'sw-part-number-accordion-release-snapshot-' + swPartNumber.id"
                              businessObject="swPartNumber"
                              [businessId]="swPartNumber.id"
                            >
                              <app-rocket-icon></app-rocket-icon>
                            </button>
                          }
                          @if (swPartNumber.state == swPartNumberState.Dev) {
                            <button
                              *appIfPolicySatisfied="policy.canDeleteSoftSwPartNumber"
                              (click)="$event.stopPropagation(); swPartNumberSoftDeleteClicked.emit(swPartNumber)"
                              type="button"
                              class="font-medium text-red-400 disabled:text-gray-400 hover:text-red-600 cursor-pointer hover:scale-110"
                              appAgentAction
                              [agent]="'sw-part-number-accordion-delete-sw-part-number-' + swPartNumber.id"
                              businessObject="swPartNumber"
                              [businessId]="swPartNumber.id"
                              action="delete"
                            >
                              <app-delete-icon></app-delete-icon>
                            </button>
                            <button
                              *appIfPolicySatisfied="policy.canCreateSwPartNumberSnapshot"
                              (click)="$event.stopPropagation(); toggleEnterSnapshotMinorVersion(swPartNumber)"
                              type="button"
                              class="font-medium text-blue-400 disabled:text-gray-400 hover:text-blue-600 cursor-pointer hover:scale-110"
                              appAgentAction
                              [agent]="'sw-part-number-accordion-add-snapshot-' + swPartNumber.id"
                              businessObject="swPartNumber"
                              [businessId]="swPartNumber.id"
                              action="add"
                            >
                              <app-add></app-add>
                            </button>
                            <button
                              *appIfPolicySatisfied="policy.canCreateSwPartNumber"
                              (click)="$event.stopPropagation(); createNewBranchClicked.emit(swPartNumber)"
                              type="button"
                              class="font-medium text-blue-500 disabled:text-gray-400 hover:text-blue-700 cursor-pointer hover:scale-110"
                              appAgentAction
                              [agent]="'sw-part-number-accordion-create-branch-' + swPartNumber.id"
                              businessObject="swPartNumber"
                              [businessId]="swPartNumber.id"
                              action="add"
                            >
                              <app-branch-icon></app-branch-icon>
                            </button>
                            <div class="flex items-center mt-1">
                              <app-export-popover
                                [swPartNumber]="swPartNumber"
                                (swPartNumberDocDownloadClicked)="swPartNumberDocDownloadClicked.emit($event)"
                                (swPartNumberDownloadClicked)="swPartNumberDownloadClicked.emit($event)"
                                (resetOnTerminalExportedClicked)="resetOnTerminalExportedClicked.emit($event)"
                                (resetDocumentationExportedClicked)="resetDocumentationExportedClicked.emit($event)"
                                (publishEventsClicked)="publishEventsClicked.emit($event)"
                              ></app-export-popover>
                            </div>
                            <div class="flex items-center mt-1">
                              <app-import-popover
                                [swPartNumber]="swPartNumber"
                                (importClicked)="setUpload($event.swPartNumber, $event.importType)"
                              ></app-import-popover>
                            </div>
                          }
                          @if (swPartNumber.internalNotes) {
                            <app-note-icon class="text-orange-300 self-center"></app-note-icon>
                          }
                        </div>
                      </div>
                      @if (swPartNumberForSnapshot?.id === swPartNumber.id) {
                        <div class="my-2 me-2 flex justify-end gap-x-2">
                          <app-snapshot-minor-release
                            (minorSelected)="snapshotMinorReleaseSelected($event)"
                          ></app-snapshot-minor-release>
                          <button
                            (click)="triggerCreateSnapshot()"
                            class="font-medium bg-amazone-orange rounded-md text-white disabled:text-gray-400 cursor-pointer hover:scale-110 px-2 disabled:cursor-not-allowed disabled:bg-gray-200"
                            appAgentAction
                            [agent]="'sw-part-number-accordion-create-snapshot-' + swPartNumber.id"
                            businessObject="swPartNumber"
                            [businessId]="swPartNumber.id"
                            action="confirm"
                          >
                            <app-check></app-check>
                          </button>
                        </div>
                      }
                      @if (swPartNumberForUpload?.id === swPartNumber.id) {
                        <div class="my-2 me-2 flex justify-end gap-x-2">
                          <app-upload-file
                            [labelIsHidden]="true"
                            [multiple]="true"
                            (fileSelected)="onFilesSelected($event)"
                            (closeComponent)="swPartNumberForUpload = undefined"
                          ></app-upload-file>
                          <button
                            [disabled]="!xmlFiles || xmlFiles.length === 0"
                            (click)="uploadXmlFile()"
                            class="font-medium bg-amazone-orange rounded-md text-white disabled:text-gray-400 cursor-pointer hover:scale-110 px-2 disabled:cursor-not-allowed disabled:bg-gray-200"
                            appAgentAction
                            [agent]="'sw-part-number-accordion-upload-file-' + swPartNumber.id"
                            businessObject="swPartNumber"
                            [businessId]="swPartNumber.id"
                            action="import"
                          >
                            <app-check></app-check>
                          </button>
                        </div>
                      }
                      @if (
                        swPartNumber.id === report?.swPartNumberId && (report?.importReport?.logItems?.length ?? 0) > 0
                      ) {
                        <div class="relative">
                          <div class="w-full my-4 pe-10">
                            <button
                              (click)="closeReport()"
                              type="button"
                              class="absolute top-0 end-0 mt-2 me-2 font-medium text-gray-400 hover:text-gray-600 cursor-pointer hover:scale-110"
                              appAgentAction
                              [agent]="'sw-part-number-accordion-close-report-' + swPartNumber.id"
                              businessObject="swPartNumber"
                              [businessId]="swPartNumber.id"
                              action="close"
                            >
                              <app-cancel-icon></app-cancel-icon>
                            </button>
                            <app-translation-import-reporter
                              [reports]="report?.importReport?.logItems ?? []"
                              [title]="'Import warnings and errors'"
                            ></app-translation-import-reporter>
                          </div>
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </div>
    }
  } @empty {
    <div class="p-5 text-gray-500 text-center">
      <p>No part numbers available.</p>
    </div>
  }
</div>
